// React imports
import PropTypes from 'prop-types';

//  material-ui imports
import { Typography, Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// material-ui icons
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

// project imports
import FileMngrIcon from '../icon/FileMngrIcon';

// ==============================|| FILEMNGR TOOLBAR BUTTON ||============================== //

const FileMngrToolbarButton = ({ onClick, icon, text, disabled, hasMenu, isLoading }) => {
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? '#FFFFFF' : '#656565';
    return (
        <Button
            onClick={(ev) => {
                if (typeof onClick === 'function') {
                    onClick(ev);
                }
            }}
            color="inherit"
            disabled={!!disabled}
            title={text}
            aria-controls="toolbar-menu"
            aria-haspopup={hasMenu}
            size={theme.breakpoints.down('md') ? 'small' : 'medium'}
        >
            {!isLoading && (
                <>
                    <FileMngrIcon
                        color={disabled === true ? '#BEBEBE' : '#656565'}
                        icon={icon}
                        sx={{ fontSize: 16, opacity: disabled === true ? 0.5 : undefined }}
                    />
                    &nbsp;
                    <Typography
                        variant="button"
                        color={textColor}
                        sx={{
                            fontSize: 13,
                            [theme.breakpoints.down('md')]: { display: 'none' },
                            opacity: disabled === true ? 0.5 : undefined
                        }}
                    >
                        {text}
                    </Typography>
                    &nbsp;
                    {hasMenu && (
                        <FileMngrIcon color={disabled === true ? '#BEBEBE' : '#656565'} sx={{ fontSize: 16 }} icon={KeyboardArrowDown} />
                    )}
                </>
            )}
            {isLoading && <CircularProgress size={16} color="primary" />}
        </Button>
    );
};

FileMngrToolbarButton.propTypes = {
    onClick: PropTypes.func,
    icon: PropTypes.any,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    hasMenu: PropTypes.bool,
    isLoading: PropTypes.bool
};

export default FileMngrToolbarButton;
